import script from "./FormBuilder.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormBuilder.vue?vue&type=script&setup=true&lang=ts"

import "./FormBuilder.vue?vue&type=style&index=0&id=0628b852&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0628b852"]])

export default __exports__